<div class="square-container" *ngIf="formSeguroUno && formSeguroDos">
    <div class="square">
        <div id="content-img-portada-principal">
            <img src="../../../../assets/images/familia.PNG" alt="">
        </div>
        <div id="content-form-principal">
            <h1 class="text-color-primary titulo-principal">{{'calcular-seguro.titulo' | translate}}</h1>
            <div class="input-form" *ngIf="mostrarPrimerConjunto" [formGroup]="formSeguroUno">
                <label id="fecha-nacimiento" for="date-inputs">{{'calcular-seguro.pregunta.cuando-naciste' |
                    translate}}</label>
                <div class="date-inputs field mb-1">
                    <div class="">
                        <label for="dia">{{'calcular-seguro.pregunta.cuando-naciste.dia' | translate}}</label>
                        <input type="number" id="dia" name="dia" formControlName="dia" class="input-form-control">
                    </div>
                    <div class="">
                        <label for="mes">{{'calcular-seguro.pregunta.cuando-naciste.mes' | translate}}</label>
                        <input type="number" id="mes" name="mes" formControlName="mes" class="input-form-control">
                    </div>
                    <div class="">
                        <label for="anio">{{'calcular-seguro.pregunta.cuando-naciste.anio' | translate}}</label>
                        <input type="number" id="anio" formControlName="anio" class="input-form-control input-anio">
                    </div>
                </div>
                <div class="mb-1">
                    <label id="proteger">{{'calcular-seguro.pregunta.que-quieres-proteger' | translate}}</label>
                    <div class="field">
                        <div class="box input-form-control"
                            [class.selected]="poliza.tipoPoliza.id===CONSTANTES_APP.TIPO_POLIZA_FAMILIA"
                            (click)="setTipoPoliza(CONSTANTES_APP.TIPO_POLIZA_FAMILIA)">
                            {{'calcular-seguro.pregunta.que-quieres-proteger.familia' | translate}}</div>
                        <div class="box input-form-control"
                            [class.selected]="poliza.tipoPoliza.id===CONSTANTES_APP.TIPO_POLIZA_HIPOTECA"
                            (click)="setTipoPoliza(CONSTANTES_APP.TIPO_POLIZA_HIPOTECA)">
                            {{'calcular-seguro.pregunta.que-quieres-proteger.hipoteca' | translate}}</div>
                    </div>
                </div>
                <div class="input-capital">
                    <label for="capital">{{'calcular-seguro.pregunta.capital.cobertura' | translate}}</label>
                    <div class="input-capital">
                        <div class="flex-container" [ngClass]="{'show-input': mostrarInputOtroCapital}">
                            <select id="capital" name="capital" formControlName="cobertura" class="input-form-control"
                                (change)="actualizarCapitalCobertura($event)">
                                <option *ngFor="let opcion of opcionesCapital" [value]="opcion">{{ opcion |
                                    currencyEuroSinDecimales }}</option>
                                <option value="otro">{{'calcular-seguro.pregunta.capital.cobertura.otro' | translate}}
                                </option>
                            </select>
                            <input class="otro-capital input-form-control" type="number" *ngIf="mostrarInputOtroCapital"
                                formControlName="otroCapital" placeholder="Introduce el capital">
                            <div *ngIf="formSeguroUno.controls['otroCapital'].errors"
                                class="content-validacion-form mt-0">
                                <div [translate]="'otro-capital-cobertura.error'"
                                    [translateParams]="{value: maxCapital | currencyEuroSinDecimales}"></div>
                            </div>
                        </div>
                        <p><span id="info" (click)="mostrarModalInfo()" class="text-color-primary">&#9432;</span><span
                                class="txt-small">{{'calcular-seguro.pregunta.capital.cobertura.consejo'
                                | translate}}</span></p>
                    </div>
                </div>

                <div class="content-siguiente">
                    <app-generic-field-button-next-back [direccion]="'next'" [texto]="'Siguiente'" [estilo]="'simple'"
                        (eventoClick)="siguiente()">
                    </app-generic-field-button-next-back>
                </div>
            </div>
            <div class="input-form" *ngIf="!mostrarPrimerConjunto" [formGroup]="formSeguroDos">
                <div class="input-email">
                    <label for="email">{{'calcular-seguro.pregunta.email' | translate}}</label>
                    <input type="email" id="email" name="email" placeholder="Escribe tu correo electrónico"
                        formControlName="email" class="input-form-control">
                    <div *ngIf="formDos['email'].errors" class="content-validacion-form custom-error-small">
                        <div>{{getError(formDos['email'])}}</div>
                    </div>
                </div>
                <div class="input-telefono">
                    <label for="telefono">{{'calcular-seguro.pregunta.telefono' | translate}}</label>
                    <input type="tel" id="telefono" name="telefono" placeholder="(+34) 600 11 22 33"
                        formControlName="telefono" class="input-form-control">
                    <div *ngIf="formDos['telefono'].errors" class="content-validacion-form">
                        <div>{{getError(formDos['telefono'])}}</div>
                    </div>
                </div>
                <div class="checkbox-container">
                    <input type="checkbox" class="custom-checkbox" id="acepto" name="acepto" [(ngModel)]="acepto"
                        [ngModelOptions]="{standalone: true}">
                    <label for="acepto" class="txt-xsmall">{{'calcular-seguro.check.terminos' | translate}} <a
                            (click)="abrirModalInformativo($event)"
                            class="enlace-politica-privacidad">{{'calcular-seguro.check.politicas' |
                            translate}}</a></label>
                </div>
                <div class="checkbox-container">
                    <input type="checkbox" class="custom-checkbox" id="declaracionVeraz" name="declaracionVeraz"
                        [(ngModel)]="declaracionVeraz" [ngModelOptions]="{standalone: true}">
                    <label for="declaracionVeraz"
                        class="terminos-condiciones txt-xsmall">{{'calcular-seguro.check.declaracion-veraz' |
                        translate}}</label>
                </div>

                <div class="content-validacion-form-general text-center">
                    <span>{{mensajeValidacionForm}}</span>
                </div>

                <div class="content-siguiente">
                    <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'"
                        [estilo]="'border'" (eventoClick)="retroceder()">
                    </app-generic-field-button-next-back>
                    <app-generic-field-button-next-back [direccion]="'next'" [texto]="'Ver mi precio'"
                        [estilo]="'simple'" (eventoClick)="verPrecio()">
                    </app-generic-field-button-next-back>
                </div>
            </div>
        </div>
    </div>
</div>